import React from 'react'
import {Flex} from '/app/src/component'

class ButtonBar extends React.Component {
    render() {
        const ButtonBarProps=  {
            padding: '10px 30px',
            hAlignContent: 'right',
            vAlignContent: 'center',
            height: '78px',
            width: '100%',
        }
        return <Flex
                {...this.props}{...ButtonBarProps}>
                    {this.props.children}
        </Flex>
    }
}



export default ButtonBar



// WEBPACK FOOTER //
// ./src/layoutComponent/Dashboard/MainPanel/ButtonBar.js